import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface HoodProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function Hood(props: HoodProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Hood"
      width={384}
      height={450}
      viewBox="0 0 384 450"
      position={{top: 26, left: 10}}
    >
      {/* HoodMainPart */}
      <path
        d="M334 449L111 444C94.1149 440.122 33.2801 385.083 21 357C8.26835 327.884 14.2294 272.03 6 257C6 257 0.999897 245.811 1 239L1 225L1 211C0.999897 204.189 6 193 6 193C14.2294 177.97 8.26835 122.116 21 93.0002C33.2801 64.9167 94.1149 9.87823 111 6.00009L334 1.00012C344 1 367.6 4.00012 382 20.0001C370.667 41.6668 348 107.2 348 192L348 225V258C348 342.8 370.667 408.333 382 430C367.6 446 344 449 334 449Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M334 449L111 444C94.1149 440.122 33.2801 385.083 21 357C8.26835 327.884 14.2294 272.03 6 257C6 257 0.999897 245.811 1 239L1 225L1 211C0.999897 204.189 6 193 6 193C14.2294 177.97 8.26835 122.116 21 93.0002C33.2801 64.9167 94.1149 9.87823 111 6.00009L334 1.00012C344 1 367.6 4.00012 382 20.0001C370.667 41.6668 348 107.2 348 192L348 225V258C348 342.8 370.667 408.333 382 430C367.6 446 344 449 334 449Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />

      {/* HoodFrontBadge */}
      <circle
        cx="21.0011"
        cy="225.001"
        r="10.0011"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></circle>
      <circle
        cx="21.0011"
        cy="225.001"
        r="10.0011"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
